import gql from 'graphql-tag';

export const mutationSendDokkioUserInvitation = gql`
  mutation sendDokkioUserInvitation (
    $dokkioUserID: DokkioID!
  ) {
    sendDokkioUserInvitation (
      dokkioUserID: $dokkioUserID
    )
  }
`;
export default mutationSendDokkioUserInvitation;
